jQuery(document).ready(function( $ ){
	// START JQUERY


	forms_validate_enable = (typeof forms_validate_enable !== 'undefined')? forms_validate_enable : true;
	forms_validate_class = (typeof forms_validate_class !== 'undefined')? forms_validate_class : 'needs-validation';
	forms_validate_success = (typeof forms_validate_success !== 'undefined')? forms_validate_success : 'was-validated';

	forms_privacy_enable = (typeof forms_privacy_enable !== 'undefined')? forms_privacy_enable : true;
	forms_privacy_id = (typeof forms_privacy_id !== 'undefined')? forms_privacy_id : '#PrivacyCheckAll';
	forms_privacy_checkbox = (typeof forms_privacy_checkbox !== 'undefined')? forms_privacy_checkbox : '.privacy-check';

	forms_fill_enable = (typeof forms_fill_enable !== 'undefined')? forms_fill_enable : true;

	forms_privacy_check_enable = (typeof forms_privacy_check_enable !== 'undefined')? forms_privacy_check_enable : true;
  forms_privacy_check_btn = (typeof forms_privacy_check_btn !== 'undefined')? forms_privacy_check_btn : '#send-btn';
	forms_privacy_check_trigger = (typeof forms_privacy_check_trigger !== 'undefined')? forms_privacy_check_trigger : '#PrivacyConsent';

	forms_block_enable = (typeof forms_block_enable !== 'undefined')? forms_block_enable : true;
	forms_block = (typeof forms_block !== 'undefined')? forms_block : false;




	// DISABLE SEND NUTTON - CHECK PRIVACY FIRST
	if(forms_privacy_check_enable) {

		function checkSendBtn() {
			if($(forms_privacy_check_trigger).prop('checked')) {
				$(forms_privacy_check_btn).prop('disabled', false);
				if(logit == 2) console.log('[PRIVACY CHECK] Enabled button - ref ' + $(forms_privacy_check_trigger).prop('checked'));

			} else {
				$(forms_privacy_check_btn).prop('disabled', true);
				if(logit == 2) console.log('[PRIVACY CHECK] Disabled button - ref ' + $(forms_privacy_check_trigger).prop('checked'));
			}
		}

		$(forms_privacy_check_trigger).change(function(){
			if(this.checked) {
				$(forms_privacy_check_btn).prop('disabled', false);
					if(logit == 2) console.log('[PRIVACY CHECK] Enabled button');
			} else {
				$(forms_privacy_check_btn).prop('disabled', true);
					if(logit == 2) console.log('[PRIVACY CHECK] Disabled button');
			}
		});

		console.log('[PRIVACY CHECK] Enabled: ' + forms_privacy_check_trigger + ', ' + forms_privacy_check_btn);
		checkSendBtn();

	}





	// PRIVACY CHECKBOX HELPER
	if(forms_privacy_enable) {
		$(forms_privacy_id).click(function(){
			if(this.checked) {
				$(forms_privacy_checkbox).prop('checked', true);
			} else {
				$(forms_privacy_checkbox).prop('checked', false);
			}

			if(forms_privacy_check_enable) checkSendBtn();

		});
	}




	// FORM VALIDATION (BOOTSTRAP)
	if(forms_validate_enable) {
		(function() {
			'use strict';
				// Fetch all the forms we want to apply custom Bootstrap validation styles to
				var forms = document.getElementsByClassName(forms_validate_class);
				// Loop over them and prevent submission
				var validation = Array.prototype.filter.call(forms, function(form) {
					form.addEventListener('submit', function(event) {
						if(forms_block && forms_block_enable) {
							event.preventDefault();
							console.log('[FORMS BLOCK] Activated!');
						}
						if (form.checkValidity() === false) {
							event.preventDefault();
							event.stopPropagation();
						}
						form.classList.add(forms_validate_success);
					}, false);
				});
		})();
	}

// END JQUERY
});
